import { EnterpriseDashboardBudgetChartData } from './enterprise-dashboard-budget-chart-data';
import { EnterpriseDashboardLocationDetails } from './enterprise-dashboard-location-details';

export class EnterpriseDashboardBudgetLocationDetails extends EnterpriseDashboardLocationDetails {
	public totalActualCost: number;
	public totalCurrentBudgetCost: number;
	public monthlyActualCost: number;
	public underBudgetPercent: number;

	public monthlyChartData: EnterpriseDashboardBudgetChartData[];

	constructor(enterpriseDashboardBudgetLocationDetails?: EnterpriseDashboardBudgetLocationDetails) {
		super(enterpriseDashboardBudgetLocationDetails);
		Object.assign(this, enterpriseDashboardBudgetLocationDetails);

		this.monthlyChartData = this.monthlyChartData ? this.monthlyChartData.map(m => new EnterpriseDashboardBudgetChartData(m)) : [];
	}
}
